import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '黑料分类',
    links: [
      { label: '内幕揭秘', to: '/category/insider-reveal' },
      { label: '丑闻曝光', to: '/category/scandal-expose' },
      { label: '独家黑料', to: '/category/exclusive' },
      { label: '财经黑幕', to: '/category/finance' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '联系我们', to: '/about#contact' },
      { label: '用户协议', to: '/about' },
      { label: '隐私政策', to: '/about' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { label: '中国互联网举报中心', to: 'https://www.12377.cn', external: true },
      { label: '国家网信办', to: 'https://www.cac.gov.cn', external: true },
      { label: '消费者协会', to: 'https://www.cca.org.cn', external: true },
      { label: '市场监督总局', to: 'https://www.samr.gov.cn', external: true },
    ],
  },
];

const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-wechat-line', label: '微信', href: '#' },
  { icon: 'ri-tiktok-line', label: '抖音', href: '#' },
  { icon: 'ri-bilibili-line', label: 'B站', href: '#' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || submitting) return;

    // Check honeypot
    const honeypot = (e.currentTarget as HTMLFormElement).querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim()) {
      setSubmitted(true);
      return;
    }

    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email.trim());

      await fetch('https://readdy.ai/api/form/d914o7i181e9e92u9940', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
    } catch {
      // silently handle
    } finally {
      setSubmitting(false);
      setSubmitted(true);
      setEmail('');
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-heading text-2xl font-bold text-primary-500">
                51<span className="text-foreground-50">黑料网</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-sm">
              51黑料网专注于曝光各类黑料、内幕、丑闻等内容，致力于为公众提供真实可靠的信息参考。每日更新，独家爆料，还原事件真相。
            </p>
            <div className="flex items-center gap-4 mt-5">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200/60 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors duration-200 cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Link Columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) =>
                  link.external ? (
                    <li key={link.label}>
                      <a
                        href={link.to}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-200 cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-200 cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Subscribe Section */}
        <div className="mt-12 pt-10 border-t border-background-200/40">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div>
              <h4 className="text-base font-semibold text-foreground-100">每日黑料推送</h4>
              <p className="text-sm text-foreground-500 mt-1">订阅我们的邮件通知，第一时间获取最新曝光内容。</p>
            </div>
            {submitted ? (
              <div className="flex items-center gap-2 text-accent-400 text-sm">
                <i className="ri-checkbox-circle-line text-lg"></i>
                <span>订阅成功！感谢您的关注。</span>
              </div>
            ) : (
              <form
                onSubmit={handleSubscribe}
                className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto"
                data-readdy-form=""
              >
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  required
                  className="px-4 py-3 bg-background-50 border border-background-300/60 rounded-md text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/60 transition-colors duration-200 w-full lg:w-72"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-6 py-3 bg-primary-500 text-foreground-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {submitting ? '订阅中...' : '立即订阅'}
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 51黑料网 All Rights Reserved.
          </p>
          <p className="text-xs text-foreground-600">
            京ICP备2026XXXXXXXX号-1 | 互联网新闻信息服务许可证
          </p>
        </div>
      </div>
    </footer>
  );
}